import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import SingleGrowl from '../components/SingleGrowl';
import './GrowlerMessages.css';

class GrowlerMessages extends React.Component {
  render() {
    let count = 0;
    const maxShown = 8;
    const { messages } = this.props;
    const msgTags = [];
    _.forIn(messages, (msg, code) => {
      if (++count < maxShown) {
        msgTags.push(<SingleGrowl key={code} type={msg.type} message={msg.message}/>);
      }
    });

    return (
      <div className="c-growler-messages">
        <ul>
          {msgTags}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    messages: state.messages
  };
};

export default connect(mapStateToProps)(GrowlerMessages);



// WEBPACK FOOTER //
// ./src/containers/GrowlerMessages.js